import script from "./EMailTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./EMailTags.vue?vue&type=script&setup=true&lang=ts"

import "./EMailTags.vue?vue&type=style&index=0&id=7393902a&lang=scss"

const __exports__ = script;

export default __exports__